<template>
  <div class="about block">
    <b-row>
      <b-col class="col__text">

        <div class="about__title">
          <transition name="fade" mode="out-in">
            <div v-if="language === 'HU'" key="about-hu" class="d-flex">
              <p class="font__futura-pt-bold">RÓLUNK</p>
            </div>

            <div v-if="language === 'EN'" key="about-en" class="d-flex">
              <p class="font__futura-pt-bold">WHAT WE DO</p>
            </div>
          </transition>


        </div>

        <transition name="fade" mode="out-in">
          <div v-if="language === 'HU'" key="about-hu">
            <p class="font__futura-book-std text">
              Az ASAN Budapest zenei kollektíva 2014-ben alakult, és évekig független kiadóként mûködött. Az underground térbõl építkezõ label fõleg basszus zenei, soul-elektronikus és hip hop mûfajú kiadványokat gondoz.
              Szervezõként is tevékenyek, olyan fellépõket szállítottak már a Brit szcénából Budapestre, mint az Ivy Lab, The Mouse Outfit, Om Unit, vagy Strange U (High Focus Records). Emellett workshop-ok, kiállítások és egyéb kulturális rendezvények szervezését is vállalják.
              <br/>
              <br/>
              A kiadó 2017-ben indította el saját stúdióját, ahol elsõsorban hang utómunkával foglalkoztak (mixing, mastering). Az ASAN Soundlab-hez tartozó zenei producerek ma már sokoldalúan alkotnak. Készítenek alapokat egyéni felhasználásra (alkalmazott zeneszerzés, full production), értékesítenek B2B háttérzenei tartalmakat (és ezekhez felhasználási jogot) a tudományos-, technikai- és felsõ kategóriás divat szegmensek felé, vállalnak hangutómunkát, valamint aktívak önálló elõadómûvészként is.
              A zenei anyagokhoz tartozó komplett branding-, arculati- és egyéb grafikai munkák elkészítése is a kiadó profiljához tartozik.
              360 fokos konstrukcióban mûködnek, a zeneipari infrastruktúrához tartozó feladatok egy része kiszervezés által,  partner kapcsolatokon keresztül valósul meg.
              <br/>
              <br/>
              Az ASAN Budapest központi helyszíne (HUB) a VII. kerületben található. Itt mûködik az iroda és egy elkülöníthetõ stúdió rész, valamint kreatív-közösségi térként is funkcionál. A helyiség alkalmas releváns workshop-ok szervezésére, live session-ök felvételére és podcastok gyártására is.
            </p>
            <p class="font__futura-std-heavy">
              Teljes podcast csomagunk már elérhetõ. Rögzítheted mûsorod hanganyagát, vállaljuk a hozzá tartozó háttérzenei tartalmak gyártását és a kapcsolódó hangutómunkát is.
            </p>
          </div>

          <div v-if="language === 'EN'" key="about-en">
            <p class="font__futura-book-std text">
              The ASAN Budapest collective was formed as an indie label back in 2014. From the outset we released music from different genres like underground bass music, soul-electronic and hip-hop.
              Through the years we have booked artists from across the UK scene such as Ivy Lab, The Mouse Outfit, Om Unit, and the Strange U (High Focus Records) to perform in the Budapest club scene. We have also promoted multiple workshops, exhibitions and other events of fine art.
              <br/>
              <br/>
              The first studio launched in 2017 where we started working on audio post-production (mixing, mastering) and sound design. The music producers on our label have a wide variety of creative outlets, from composing beats and background music for custom use as well as license and sync (ads for science/tech/fashion segment and podcasts), they also release their own music as artists.
              Even though music production is our main profile, we work as a 360 service which includes branding, design and artwork. Parts of our work in the music industry are done through outsourcing partnerships.
              <br/>
              <br/>
              The ASAN Budapest HUB is located near the downtown area of Budapest. Within our space we have created a relaxed and chilled environment where it is easy to get into a vibe as you work in the isolated soundlab section, and it's also a great creative community area to meet like minded individuals.
              The HUB is fitted for workshops, recording live sessions and podcasts as well.
            </p>
            <p class="font__futura-std-heavy">
              Podcasting is available as a full service. You can record or stream your show, licence intro/background music and get all the post-production works in one package.
            </p>
          </div>
        </transition>






      </b-col>
      <b-col >
        <img src="../assets/img/ASAN_01.png" alt="about"/>
<!--        <div style="width: 400px; height: 536px; background-color: #f6f6f6;"/>-->
<!--        <img src="../assets/img/about.png" alt="about"/>-->
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "About.vue",
  computed: {
    language: function () {
      return this.$store.getters.language;
    }
  },
}
</script>

<style scoped>
  .row .col:nth-child(1){
    padding-right: 0;
  }

  .row .col:nth-child(2){
    margin-left: 75px;
    padding-right: 0px;
  }
.font__futura-std-heavy{
  margin-top: 30px;
  line-height: 21.4pt;
  letter-spacing: 1px;
  width: 500px;
  color: var(--asan-dark-grey)
}
.col__text .text {
  font-size: 12pt;
  letter-spacing: 1px;
  line-height: 21.4pt;
  width: 500px;
  color: var(--asan-dark-grey)
}
.col__text{
  padding-right: 140px;
}
.about__title{
  margin-bottom: 20px;
}

.about{
  /*margin-top: 50px !important;*/
}
.about__title p{
  font-size: 22pt;
  letter-spacing: 2px;
  color: var(--asan-dark-grey);
}
img{
  width: 500px;
  /*margin-left: -70px;*/
  margin-top: 10px;
}

</style>